module.exports = __webpack_public_path__ + "img/soc-marks-bg-tablet.jpg";


//////////////////
// WEBPACK FOOTER
// ./img/soc-marks-bg-tablet.jpg
// module id = 195
// module chunks = 13